<template>
  <div>
    <v-mask background="rgba(0, 0, 0, 0.5)" @click="close"></v-mask>
    <div class="open-app-box">
      <div
        v-bind:class="{'ani-open-app-box animated':true,'baisonFadeInDown':true,'baisonFadeInUp':fadeOut}"
      >
        <btnClose class="close-open-app" @close="close" v-clickMusic></btnClose>
        <span class="open-app-title"></span>
        <div class="l-box">
          <div class="l-inner-box">
            <p class="p-big-title">如何下载</p>
            <p class="p-title">步骤一：</p>
            <p>请先参考安装指南，然后扫描下方的二维码，下载安装百胜棋牌手机客户端。</p>
            <p class="p-title">步骤二：</p>
            <p>开启百胜棋牌手机客户端，再次扫描下方的二维码，来快速启动帐号，登录畅玩！</p>
            <div class="rule-demo">
              <div class="l-rule-demo">
                <div class="qr-code-box">
                  <img id="qrcode" ondragstart="return false;" :src="qrCode" />
                </div>
                <div class="supoort-os-box">
                  <img
                    class="supoort-os"
                    src="@/assets/img/app/UI_shouji_AP_01_002.png"
                    ondragstart="return false;"
                  />
                </div>
                <span class="span-tips" v-if="!needRefresh">二维码有效期10分钟</span>
                <span v-else class="btn btn-refresh" @click="getData"></span>
              </div>
              <div class="r-rule-demo"></div>
            </div>
          </div>
        </div>
        <div class="r-box">
          <div class="r-inner-box">
            <p class="p-big-title">安装指南</p>
            <ul class="ul-menu">
              <li
                v-bind:class="{'btn':true,'selected':tabIndex==0}"
                v-clickMusic
                @click="tabChange(0)"
              >
                <span class="and" ondragstart="return false;"></span>
              </li>
              <li
                v-bind:class="{'btn':true,'selected':tabIndex==1}"
                v-clickMusic
                v-if="false"
                @click="tabChange(1)"
              >
                <span class="ios" ondragstart="return false;"></span>
              </li>
            </ul>
            <div class="install-tips">
              <img
                src="@/assets/img/app/UI_shouji_AZ_android_1280.png"
                v-show="tabIndex==0"
                ondragstart="return false;"
                class="animated fadeIn"
              />
              <img
                src="@/assets/img/app/UI_shouji_AZ_ios1280.png"
                v-show="tabIndex==1"
                ondragstart="return false;"
                class="animated fadeIn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import { getQrcode } from "@/api/task";
import btnClose from "@/components/btnClose.vue";
import { mapState } from "vuex";
export default {
  name: "howDownLoadApp",
  components: {
    "v-mask": vmask,
    btnClose
  },
  computed: {
    ...mapState({
      closeAllPopUp: state => state.app.closeAllPopUp
    })
  },
  data() {
    return {
      qrCode: null,
      tabIndex: 0,
      fadeOut: false,
      timer: null,
      needRefresh: false
    };
  },
  watch: {
    closeAllPopUp(val) {
      if (val.key != "downLoadApp") {
        this.close();
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getQrcode({
        identity: this.$store.state.app.appInfo.identity
      }).then(res => {
        res = res.data;
        if (res.code == 0) {
          this.qrCode = "data:image/png;base64," + res.result.qrcode;
          this.needRefresh = false;
          this.startTimer();
        }
      });
    },
    startTimer() {
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      var i = 0;
      this.timer = window.setInterval(() => {
        i++;
        if (i == 10 * 60) {
          window.clearInterval(this.timer);
          this.needRefresh = true;
        }
      }, 1000);
    },
    close() {
      this.fadeOut = true;
      setTimeout(() => {
        this.$emit("noticeClose");
        this.fadeOut = false;
      }, 300);
    },
    tabChange(index) {
      this.tabIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.open-app-box {
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  width: 6.185rem;
  z-index: 305;
  height: 3.385rem;
  display: block;
  position: fixed;
  left: 50%;
  top: 50%;
  font-size: 0.1rem;
  color: white;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
  transform: translate(-50%, -50%);
  .ani-open-app-box {
    background-image: url(~@/assets/img/app/UI_shouji_BG_01.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
  }
}

.open-app-box .close-open-app {
  position: absolute;
  right: -0.125rem;
  top: -0.125rem;
}

.open-app-box .open-app-title {
  position: absolute;
  top: 0.05rem;
  width: 1.1rem;
  height: 0.195rem;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  -o-transform: translate(-50%, 0);
  background-image: url(~@/assets/img/app/UI_shouji_title_01.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.open-app-box .l-box,
.open-app-box .r-box {
  width: 50%;
  margin-top: 0.1rem;
  float: left;
}

.open-app-box .l-box .l-inner-box {
  padding: 0.25rem;
}

.open-app-box .r-box .r-inner-box {
  padding: 0.25rem;
}

.open-app-box .l-box .rule-demo {
  width: 100%;
  height: 1.4rem;
  background-image: url(~@/assets/img/app/UI_shouji_BG_03.png);
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 0.1rem;
}

.open-app-box .l-box .rule-demo .l-rule-demo {
  float: left;
  width: 1.2rem;
}

.open-app-box .l-box .rule-demo .l-rule-demo .qr-code-box {
  width: 0.73rem;
  height: 0.73rem;
  margin: 0 auto;
  margin-top: 0.05rem;
  display: block;
}

.open-app-box .l-box .rule-demo .l-rule-demo .supoort-os-box {
  width: 0.684rem;
  height: 0.332rem;
  margin: 0 auto;
  margin-top: 0.05rem;
}

.open-app-box .l-box .rule-demo .l-rule-demo .supoort-os {
  width: 100%;
  height: 100%;
  display: block;
}

.open-app-box .l-box .rule-demo .l-rule-demo .span-tips {
  font-size: 0.05rem;
  color: #fdd800;
  margin-top: 0.025rem;
  text-align: center;
  width: 100%;
  display: block;
}

.open-app-box .l-box .rule-demo .l-rule-demo .btn-refresh {
  cursor: pointer;
  width: 0.565rem;
  height: 0.22rem;
  background-image: url(~@/assets/img/app/UI_shouji_APR_01.png);
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto;
  display: block;
}

.open-app-box .l-box .rule-demo .l-rule-demo .qr-code-box img {
  width: 100%;
  height: 100%;
  display: block;
}

.open-app-box .l-box .rule-demo .r-rule-demo {
  float: left;
  width: 1.35rem;
  height: 1.265rem;
  margin-top: 0.05rem;
  background-image: url(~@/assets/img/app/UI_shouji_saomiao_01.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.open-app-box .r-inner-box .ul-menu {
  height: 0.245rem;
  float: left;
  margin: 0;
  padding: 0;
  margin-top: 0.05rem;
}

.open-app-box .r-inner-box .install-tips {
  margin-top: 0.05rem;
  background-image: url(~@/assets/img/app/UI_shouji_BG_03.png);
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
  width: 100%;
  height: 2.25rem;
}

.open-app-box .r-inner-box .install-tips img {
  width: 100%;
  height: 100%;
}

.open-app-box .r-inner-box .ul-menu li {
  margin: 0;
  padding: 0;
  list-style: none;
  float: left;
  width: 0.825rem;
  height: 0.245rem;
  background-image: url(~@/assets/img/app/UI_shouji_button_02.png);
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.open-app-box .r-inner-box .ul-menu li .and {
  width: 0.56rem;
  height: 0.16rem;
  float: left;
  margin-top: 0.04rem;
  margin-left: 0.1325rem;
  background-image: url(~@/assets/img/app/UI_shouji_buttonA_02.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.open-app-box .r-inner-box .ul-menu li .ios {
  cursor: pointer;
  width: 0.56rem;
  height: 0.16rem;
  float: left;
  margin-top: 0.04rem;
  margin-left: 0.1325rem;
  background-image: url(~@/assets/img/app/UI_shouji_buttonP_02.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.open-app-box .r-inner-box .ul-menu li.selected {
  background-image: url(~@/assets/img/app/UI_shouji_button_01.png);
}

.open-app-box .r-inner-box .ul-menu li.selected .and {
  background-image: url(~@/assets/img/app/UI_shouji_buttonA_01.png);
}

.open-app-box .r-inner-box .ul-menu li.selected .ios {
  background-image: url(~@/assets/img/app/UI_shouji_buttonP_01.png);
}

.open-app-box p {
  margin: 0;
  padding: 0;
}

.open-app-box .p-big-title {
  font-size: 0.125rem;
  color: #fdd800;
}

.open-app-box .p-title {
  margin: 0.05rem 0;
}
@media all and (orientation: portrait) {
  .open-app-box {
    transform: translate(-50%, -50%) rotate(90deg) !important;
    -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
    -moz-transform: translate(-50%, -50%) rotate(90deg) !important;
    -ms-transform: translate(-50%, -50%) rotate(90deg) !important;
    -o-transform: translate(-50%, -50%) rotate(90deg) !important;
  }
}
</style>